// extracted by mini-css-extract-plugin
module.exports = {"content__title":"EpSentinelEventModal_content__title__jIZ4H","content__text":"EpSentinelEventModal_content__text__wDKIr"};